export default function useStreet(street: string) {
  if (!street) return street
  const data = street.split(' ')

  if (data && data.length > 0 && (!isNaN(parseInt(data[0])) || data[0].match(/\d+/g))) {
    data.splice(0, 1)
    return data.join(' ')
  }

  return street
}